import './brix-styles.scss';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const styles = () => {
    // trick for webpack
    // nice, but what is the trick?
};
